export default __webpack_public_path__ + "static/media/network_ipv6_range_24.bdb209f2.svg";